import React, { useEffect, useRef, useState } from 'react';
import {
  QueryFilter as BaseQueryFilter,
  QueryFilterProps as BaseQueryFilterProps
} from '@ant-design/pro-components';
import classnames from 'classnames';
import { isArray } from 'lodash-es';
import { Form } from 'antd';
import QueryFilterCondition from './QueryFilterCondition';

export type QueryFilterProps = BaseQueryFilterProps

type SortContextType = {
  sortIndex: number,
  createBack?: (sortIndex: number, children?: any) => void,
  destoryBack?: (sortIndex: number) => void
}

const SortContext = React.createContext<SortContextType>({
  sortIndex: 0,
});
export const Sort = ({ children }:any) => {
  const {
    sortIndex,
    createBack,
    destoryBack
  } = React.useContext(SortContext);
  React.useEffect(() => {
    createBack?.(sortIndex, children);
    return () => destoryBack?.(sortIndex);
  }, [children, sortIndex]);

  return null;
};
type QueryFilterInerface = React.FC<QueryFilterProps> & {
  Sort: typeof Sort;
  Condition: typeof QueryFilterCondition
};
const QueryFilter: QueryFilterInerface = ({
  children,
  ...props
}) => {
  const [injectClassName, setInjectClassName] = useState(true);
  const isKeyPressSubmit = useRef(true);
  const [sortChildrenMap, setSortChildrenMap] = useState<any>({});
  useEffect(() => {
    if (props.collapsed === false || props.defaultCollapsed === false) {
      setInjectClassName(false);
    }
  }, []);
  const items = React.useMemo(() => {
    let newItems: any = children;
    let sortItems: any[] = [];
    if (isArray(children)) {
      newItems = React.Children.toArray(children)
        .reduce((arr: React.ReactNode[], child: any, index: number) => {
          const sortComponent = (
            <Form.Item noStyle>
              <SortContext.Provider value={{
                sortIndex: index,
                createBack: (sortIndex: number, children: any) => {
                  setSortChildrenMap((prevState: any) => {
                    return Object.assign({}, prevState, {
                      [sortIndex]: children
                    });
                  });
                },
                destoryBack: (sortIndex: number) => {
                  setSortChildrenMap((prevState: any) => {
                    return Object.assign({}, prevState, {
                      [sortIndex]: null
                    });
                  });
                }
              }}>{child}</SortContext.Provider>
            </Form.Item>
          );
          if (sortChildrenMap[index]) {
            arr = arr.concat(React.Children.toArray(sortChildrenMap[index]));
            sortItems.push(sortComponent);
          } else {
            arr.push(sortComponent);
          }

          return arr;
        }, []);
      if (sortItems.length > 0) {
        newItems.push(
          <Form.Item hidden>{sortItems}</Form.Item>
        );
      }
    }
    return newItems;
  }, [children, sortChildrenMap]);
  return (

    <BaseQueryFilter
      span={6}
      {...props}
      children={items}
      onFinish={async (values) => {
        if (isKeyPressSubmit.current) {
          return props.onFinish?.(values);
        }
      }}
      onFocus={(e) => {
        if (e.target.tagName.toUpperCase() === 'TEXTAREA') {
          isKeyPressSubmit.current = false;
        }
        props.onFocus?.(e);
      }}
      onBlur={(e) => {
        isKeyPressSubmit.current = true;
        props.onBlur?.(e);
      }}
      onCollapse={(collapsed: boolean) => {
        setInjectClassName(collapsed);
        props.onCollapse?.(collapsed);
      }}
      className={classnames({
        'query-filter-actions-placement-left': injectClassName,
        'query-filter-form-row-col':true
      })}
    />
  );
};

QueryFilter.Sort = Sort;
QueryFilter.Condition = QueryFilterCondition;
export default QueryFilter;
